import { Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild, AfterViewChecked, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ICompanyGroup, DeviceBindingTimeUnit, IUpdateCompanyGroupBindingTimeForm } from 'app/models/company.models';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ApiService } from 'app/services/api.service';
const BINDING_TIME_SUCCESS_MSG = "BINDING_TIME_UPDATE_SUCCESS";
const LOGOUT_URL_SUCCESS_MSG = "LOGOUT_URL_UPDATE_SUCCESS";
const ERROR_MSG = "ERROR";

@Component({
    selector: 'app-company-group-binding-time',
    imports: [CommonModule, FormsModule, TranslateModule, ReactiveFormsModule],
    templateUrl: './company-group-edit-binding-time.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    styleUrls: ['./company-group-edit-binding-time.component.css']
})
export class CompanyGroupEditBindingTimeComponent implements OnChanges, AfterViewChecked {

  ngAfterViewChecked(): void {
    if (this.logoutTextarea && this.logoutUrlControl.value) {
      const el = this.logoutTextarea.nativeElement;
      if (el.scrollHeight !== el.offsetHeight) {
        this.autoGrow();
      }
    }
  }  

  constructor(private api: ApiService) { }

  @Input() companyGroup: ICompanyGroup;
  @ViewChild('logoutTextarea') logoutTextarea!: ElementRef<HTMLTextAreaElement>;

  deviceBindingTimeControl: FormControl<number>;
  deviceBindingTimeUnitControl: FormControl<DeviceBindingTimeUnit>;
  deviceBindingTimeVisibleControl: FormControl<boolean>;
  logoutUrlControl: FormControl<string>;

  updating: boolean = false;
  successMsg: string = "";
  errorMsg: string = "";

  submit(): void {
    this.resetMessages();
    this.startUpdating();

    this.api.updateCompanyGroupBindingTime(this.createBindingTimeForm())
      .subscribe(
        () => this.handleUpdateSuccess(),
        (error) => this.handleUpdateError(error)
      );
  }
  
  saveLogoutUrl(): void {
    const url = this.logoutUrlControl.value?.trim();
    if (!url) return;
    const serverId = this.companyGroup.serverIdCompanyGroupId; 
    this.api.updateCompanyGroupLogoutUrl({
      ServerIdCompanyGroupId: serverId,
      logoutUrl: this.logoutUrlControl.value
    }).subscribe(
      () => {
        this.successMsg = LOGOUT_URL_SUCCESS_MSG;
        this.stopLoading();
        this.companyGroup.logoutUrl = url;
        this.logoutUrlControl.setValue(url, { emitEvent: false });
        this.updateTextareaHeight();
      },
      (error) => {
        console.log(error)
        this.errorMsg = ERROR_MSG;
        this.stopLoading();
      }
    );
  }

  createBindingTimeForm(): IUpdateCompanyGroupBindingTimeForm {
    return {
      companyGroupId: this.companyGroup.companyGroupId,
      server: this.companyGroup.server,
      deviceBindingTime: this.deviceBindingTimeControl.value,
      deviceBindingTimeUnit: this.deviceBindingTimeUnitControl.value,
      deviceBindingTimeVisible: this.deviceBindingTimeVisibleControl.value,
    };
  }

  handleUpdateSuccess(): void {
    this.successMsg = BINDING_TIME_SUCCESS_MSG;
    this.stopLoading();
  }

  handleUpdateError(error: any): void {
    console.log(error);
    this.errorMsg = ERROR_MSG;
    this.stopLoading();
  }

  startUpdating(): void {
    this.updating = true;
    this.resetMessages();
  }

  stopLoading(): void {
    this.updating = false;
  }

  resetMessages(): void {
    this.successMsg = "";
    this.errorMsg = "";
  }

  autoGrow() {
    if (!this.logoutTextarea) return;
    const el = this.logoutTextarea.nativeElement;
    el.style.height = 'auto';
    el.style.height = el.scrollHeight + 'px';
  }

  updateTextareaHeight() {
    if (this.logoutTextarea?.nativeElement) {
      const el = this.logoutTextarea.nativeElement;
      el.style.height = '0px';
      requestAnimationFrame(() => this.autoGrow());
    }
  }
  
  copyLogoutUrl() {
    const url = this.logoutUrlControl.value;
    if (url) {
      navigator.clipboard.writeText(url).then(() => {
      }).catch(err => {
        console.error('Copy failed:', err);
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['companyGroup'] && this.companyGroup) {
      this.deviceBindingTimeUnitControl = new FormControl<DeviceBindingTimeUnit>(
        this.companyGroup.deviceBindingTimeUnit
        
      );
  
      this.deviceBindingTimeVisibleControl = new FormControl<boolean>(
        this.companyGroup.deviceBindingTimeVisible
      );
  
      this.deviceBindingTimeControl = new FormControl<number>(
        this.companyGroup.deviceBindingTime,
        [
          Validators.required,
          Validators.min(0),
          Validators.max(9999)
        ]
      );
  
      this.logoutUrlControl = new FormControl<string>(
        this.companyGroup.logoutUrl || '',
        [
          Validators.pattern(/https?:\/\/.+/)
        ]
      );
      this.logoutUrlControl.setValue(this.companyGroup.logoutUrl || '', { emitEvent: false });
      this.updateTextareaHeight();
    }
   }
  }
